import {
	AtSign,
	Bell,
	Clock,
	type LucideIcon,
	MessageSquare,
} from "lucide-react";
import type { Notification, NotificationType } from "@/adapters/api";
import { type Obra, obraUrlKey, resolveObra } from "@/features/stages/obra.ts";

export type NotificationKind = "default" | "warning";

export interface NotificationItemMeta {
	Icon: LucideIcon;
	kind: NotificationKind;
}

const TYPE_META: Record<NotificationType, NotificationItemMeta> = {
	comment_mention: { Icon: AtSign, kind: "default" },
	post_comment: { Icon: MessageSquare, kind: "default" },
	attendance_pending: { Icon: Clock, kind: "warning" },
};

const FALLBACK_META: NotificationItemMeta = { Icon: Bell, kind: "default" };

export function notificationItemMeta(
	type: NotificationType,
): NotificationItemMeta {
	return TYPE_META[type] ?? FALLBACK_META;
}

export interface NotificationRouteContext {
	obraKey: string | undefined;
	obras: Obra[] | undefined;
}

function obraKeyForWorksite(
	worksiteId: string,
	{ obraKey, obras }: NotificationRouteContext,
): string | undefined {
	const current = resolveObra(obras ?? [], obraKey);
	if (current?.canteiroId === worksiteId) return obraKey;
	const match = obras?.find((obra) => obra.canteiroId === worksiteId);
	return match ? obraUrlKey(match) : obraKey;
}

export function notificationPath(
	notification: Notification,
	context: NotificationRouteContext,
): string | undefined {
	if (notification.type === "attendance_pending") {
		if (!notification.worksite_id || !notification.reference_date) {
			return undefined;
		}
		const key = obraKeyForWorksite(notification.worksite_id, context);
		if (!key) return undefined;
		const query = new URLSearchParams({ date: notification.reference_date });
		return `/${key}/equipe?${query.toString()}`;
	}
	if (notification.post_id && context.obraKey) {
		return `/${context.obraKey}/feed/${notification.post_id}`;
	}
	return undefined;
}
